var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "manual-detail manual-page-layout" }, [
    _c("embed", {
      attrs: {
        src: _vm.userManualData.pdfUrl,
        type: "application/pdf",
        width: "100%",
        height: _vm.pdfHeight,
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }